import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { BookingChat } from '../booking-chat';
import { BookingClientFile } from '../booking-client-file';
import { BookingFileType } from '../booking-file-type';
import { BookingService } from '../service/booking.service';
import { HttpService } from '../service/http.service';
import { ToastMessageService } from '../toast-message.service';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-booking-student-zone',
  templateUrl: './booking-student-zone.component.html',
  styleUrls: ['./booking-student-zone.component.css']
})
export class BookingStudentZoneComponent implements OnInit {

  stepItems: MenuItem[] = [];
  activeIndex!: number;
  uploadedClientFiles: BookingClientFile[] = [];
  fileForms: FormGroup[] = [];
  fileTypes: BookingFileType[] = [];
  bookingChats: BookingChat[] = [];
  selectedChatMessage!: string | null;

  constructor(
    public bookingService: BookingService,
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService
  ) {
    this.updateBookingStatus(this.bookingService.selectedBookingStatus.id);
  }

  ngOnInit(): void {
    forkJoin({
      files: this.httpService.getBookingClientFilesByBookingId(this.bookingService.booking.id!),
      fileTypes: this.httpService.getAllBookingFileTypes()
    }
    ).subscribe(({ files, fileTypes }) => {
      this.uploadedClientFiles = files;
      this.fileTypes = fileTypes;
      this.initFileForms();
    });
    this.updateBookingChats();
    this.httpService.getBookingStatusByBookingId(this.bookingService.booking.id!).subscribe(res => {
      this.bookingService.selectedBookingStatus = res;
      this.updateBookingStatus(res.id);
    });
  }

  updateBookingStatus(statusId: number) {
    this.stepItems = [];
    for (let i = 0; i < this.bookingService.bookingStatuses.length; i++) {
      this.stepItems.push({ label: this.bookingService.bookingStatuses[i].name });
      if (this.bookingService.bookingStatuses[i].id == statusId) {
        this.activeIndex = i;
      }
    }
  }

  updateBookingChats() {
    this.httpService.getBookingChatsByBookingId(this.bookingService.booking.id!).subscribe(res => {
      this.bookingChats = res;
      console.log(res);
    });
  }

  initFileForms() {
    for (let file of this.uploadedClientFiles) {
      this.fileForms.push(this.builder.group({
        fileType: file.fileType,
        needsSignature: file.needsSignature
      }));
    }
  }

  downloadFile(fileId: number, fileName: string) {
    this.httpService.getBookingClientFileById(fileId).subscribe(res => {
      let binaryData = [];
      binaryData.push(res.body!);
      let downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
      downloadLink.setAttribute('download', fileName);
      document.body.appendChild(downloadLink);
      downloadLink.click();
    });
  }

  updateFile(rowIndex: number, file: BookingClientFile) {
    file.needsSignature = this.fileForms[rowIndex].value.needsSignature;
    file.fileType = this.fileForms[rowIndex].value.fileType;
    this.httpService.updateBookingClientFile(file).subscribe(() => {
      this.toastService.addSuccess("Success", "File information updated");
    }, error => this.toastService.addError("Error", error.message));
  }

  postChatMessage() {
    let chat = new BookingChat(this.selectedChatMessage!);
    this.httpService.postAuthenticatedBookingChat(chat, this.bookingService.booking.id!).subscribe(() => {
      this.toastService.addSuccess("Success", "New message posted");
      this.selectedChatMessage = null;
      this.updateBookingChats();
    }, error => {
      this.toastService.addError("Error", error.error.message);
    });
  }
}
